import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getAccessRestrictions() {
      return getState().restrictions;
    },
    isRetrieveAccessRestrictionsRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveAccessRestrictionsRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveAccessRestrictionsRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
